module.exports = __webpack_public_path__ + "static/media/puzzle_blue.edde0fc3.svg";